export { ComponentSearcher } from './component-searcher';
export type { ComponentResultPlugin } from './component-searcher';
